import gql from 'graphql-tag';
const CONSTRUCT_A_RESPONSE_ACTIVITY_FRAGMENT = gql `
  fragment ConstructAResponseActivityFragment on ConstructAResponseActivity {
    settings {
      minCharacterCount
      maxCharacterCount
    }
    emptyAttempt {
      id
      audioId
      audio {
        id
        src
        description
      }
    }
    incorrectAttempt {
      id
      audioId
      audio {
        id
        src
        description
      }
    }
    rounds {
      roundInstructions: instructions {
        id
        audioId
        audio {
          id
          src
          description
        }
      }
      questionHtml {
        id
        elements
      }
    }
  }
`;
export default CONSTRUCT_A_RESPONSE_ACTIVITY_FRAGMENT;
